import CircularProgress from 'material-ui/CircularProgress';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from 'styles/index';

import { getAnalyticsLinksList } from 'actions/analytics/linksList';

import LinksList from './LinksList';

function AnalyticsDashboard({ isLoaded, getAnalyticsLinksList }) {

    useEffect(() => {
        getAnalyticsLinksList();
    }, []);

    return (
        <div className='table-page'>
            <CircularProgress
                className={!isLoaded ? '' : 'hidden'}
                style={styles.circularProgress}
            />

            <div className={isLoaded ? '' : 'hidden'}>
                <div className='container'>
                    <h2>Analytics dashboard</h2>
                    <LinksList />
                </div>
            </div>
        </div>
    );
}


export default connect(
    (state) => {
        return {
            isLoaded: true,
        };
    },
    dispatch => bindActionCreators(
        {
            getAnalyticsLinksList,
        },
        dispatch,
    ),
)(AnalyticsDashboard);



// WEBPACK FOOTER //
// ./app/components/Analytics/AnalyticsDashboard.jsx